import { useEffect } from 'react'

import { sendAnalyticsEvent } from 'services/analytics'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'

import profileActions from 'models/ProfileInfo/actions'
import authenticationActions from 'models/Authentication/actions'
import profileSelectors from 'models/ProfileInfo/selectors'

import ScribbleBackground from 'components/ScribbleBackground'
import UnauthenticatedLayout, { UNAUTHENTICATED_BACKGROUND_KEYS } from 'components/UnauthenticatedLayout'

import { EVENT_TYPE } from 'resources'
import { STRING } from 'resources/string'
import { APP_URLS } from 'resources/urls'

import { Container, Description, Title, CardButton, LinkButton } from './styles'

const LockedScreen = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const isLockedByAdmin = useSelector(profileSelectors.getIsLockedByAdmin)

  const handleSignOut = () => {
    sendAnalyticsEvent(EVENT_TYPE.accountLockedScreenAcknowledgeClick)
    dispatch(
      authenticationActions.signOutUser.init((isSuccess) => {
        if (isSuccess) {
          sendAnalyticsEvent(EVENT_TYPE.accountSignOut)
        }
      }),
    )
  }

  useEffect(() => {
    dispatch(profileActions.fetchProfileInfo.init())
    sendAnalyticsEvent(EVENT_TYPE.accountLockedScreenView)
  }, [dispatch])

  useEffect(() => {
    if (!isLockedByAdmin) {
      history.replace(APP_URLS.REKLAIM)
    }
  }, [isLockedByAdmin, history])

  return (
    <UnauthenticatedLayout backgroundKey={UNAUTHENTICATED_BACKGROUND_KEYS.peopleWithLogo}>
      <ScribbleBackground>
        <Container>
          <Title>{STRING.lockedScreen.title}</Title>
          <Description>{STRING.lockedScreen.description}</Description>
          <CardButton>
            <LinkButton onClick={handleSignOut} href={APP_URLS.SIGN_OUT}>
              {STRING.lockedScreen.button}
            </LinkButton>
          </CardButton>
        </Container>
      </ScribbleBackground>
    </UnauthenticatedLayout>
  )
}

export default LockedScreen
